import { render, staticRenderFns } from "./LocationsSummaryDashboard.vue?vue&type=template&id=8d2b6310&scoped=true"
import script from "./LocationsSummaryDashboard.vue?vue&type=script&lang=js"
export * from "./LocationsSummaryDashboard.vue?vue&type=script&lang=js"
import style0 from "./LocationsSummaryDashboard.vue?vue&type=style&index=0&id=8d2b6310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2b6310",
  null
  
)

export default component.exports